import type { JSX } from 'react';
import { useReveal } from '@hooks/useReveal';
import { useContent } from '@data';
import './AiMaturity.css';

const SCALE_MAX = 4;

export default function AiMaturity(): JSX.Element {
  const ref = useReveal();
  const { AI_MATURITY } = useContent();
  const fillPct = `${String((AI_MATURITY.position / SCALE_MAX) * 100)}%`;

  return (
    <section className="AiMaturity" aria-labelledby="ai-maturity-title">
      <div className="AiMaturity__inner reveal" ref={ref}>
        <p className="AiMaturity__label">{AI_MATURITY.label}</p>
        <h2 className="AiMaturity__title" id="ai-maturity-title">{AI_MATURITY.title}</h2>
        {AI_MATURITY.paragraphs.map((text) => (
          <p className="AiMaturity__body" key={text.slice(0, 24)}>{text}</p>
        ))}

        <div className="AiMaturity__gauge">
          <div className="AiMaturity__track">
            <div className="AiMaturity__fill" style={{ '--fill': fillPct } as React.CSSProperties} />
            <div className="AiMaturity__marker" style={{ left: fillPct }}>
              <span className="AiMaturity__markerLabel">{AI_MATURITY.markerLabel}</span>
            </div>
          </div>
          <div className="AiMaturity__ticks" aria-hidden="true">
            {AI_MATURITY.levels.map((level) => (
              <span
                className="AiMaturity__tick"
                key={level.value}
                style={{ left: `${String((level.value / SCALE_MAX) * 100)}%` }}
              >
                {level.value}
              </span>
            ))}
          </div>
        </div>

        <ul className="AiMaturity__legend">
          {AI_MATURITY.levels.map((level) => {
            const isCurrent = level.value === Math.floor(AI_MATURITY.position)
              || level.value === Math.ceil(AI_MATURITY.position);
            return (
              <li
                className={'AiMaturity__level' + (isCurrent ? ' AiMaturity__level--current' : '')}
                key={level.value}
              >
                <span className="AiMaturity__levelValue">{level.value}</span>
                <span className="AiMaturity__levelName">{level.name}</span>
                <span className="AiMaturity__levelCaption">{level.caption}</span>
              </li>
            );
          })}
        </ul>

        <p className="AiMaturity__source">{AI_MATURITY.sourceNote}</p>
      </div>
    </section>
  );
}
